import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnDestroy,
    OnInit,
    signal,
    ViewEncapsulation,
    WritableSignal
} from '@angular/core';
import { interval, startWith, Subject, Subscription, switchMap } from 'rxjs';
import { IconButtonComponent } from '../../../../button/button.component';
import { IconComponent } from '../../../../icon/icon.component';
import { LinkComponent } from '../../../../link/link.component';
import { CarouselItem } from './models/carousel.type';

@Component({
    selector: 'nw-navigation-bar-carousel',
    imports: [IconComponent, IconButtonComponent, LinkComponent],
    templateUrl: './carousel.component.html',
    styleUrl: './carousel.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None
})
export class NavigationBarCarouselComponent implements OnInit, OnDestroy {
    @Input() items?: CarouselItem[];

    public selectedIndex$$: WritableSignal<number> = signal(0);
    public hover: boolean = false;

    private resetSubject = new Subject<void>();
    private subscription!: Subscription;

    public ngOnInit(): void {
        this.subscription = this.resetSubject
            .pipe(
                startWith(null),
                switchMap(() => interval(10000))
            )
            .subscribe(() => this.nextItem());
    }

    public ngOnDestroy(): void {
        if (this.subscription) this.subscription.unsubscribe();
    }

    public nextItem(): void {
        this.resetSubject.next();
        this.selectedIndex$$.set(
            this.selectedIndex$$() >= (this.items?.length || 0) - 1
                ? 0
                : this.selectedIndex$$() + 1
        );
    }

    public previousItem(): void {
        this.resetSubject.next();
        this.selectedIndex$$.set(
            this.selectedIndex$$() > 0
                ? this.selectedIndex$$() - 1
                : (this.items?.length || 0) - 1
        );
    }
}
